export default "__VITE_ASSET__6af0e52b__"